export default "/profile/images/OneBox.svg?3dd742d30cd8f6a7d68992294bbc3bbc";